import React from "react";
import { Navigate } from "react-router-dom";
import ConsoleHelper from "utils/ConsoleHelper";

const RequireAuthVerifiedNotSubscribed = ({
  children,
  isAuth,
  isVerified,
  hasActiveSubscription,
}) => {
  console.log("isAuth", isAuth);
  console.log("isVerified", isVerified);
  console.log("hasActiveSubscription", hasActiveSubscription);
  // If not authenticated, redirect to login
  if (!isAuth) {
    ConsoleHelper(
      "RequireAuthVerifiedNotSubscribed",
      "User is not authenticated, redirecting to login"
    );
    return <Navigate to="/auth/login" replace />;
  }

  if (!isVerified) {
    ConsoleHelper(
      "RequireAuthVerifiedNotSubscribed",
      "User is not verified, redirecting to verify"
    );
    return <Navigate to="/verify" replace />;
  }
  // If authenticated, verified but no subscription => show child
  if (hasActiveSubscription) {
    ConsoleHelper(
      "RequireAuthVerifiedNotSubscribed",
      "User has an active subscription, redirecting to main area"
    );
    return <Navigate to="/app" replace />;
  }
  return children;
};

export default RequireAuthVerifiedNotSubscribed;
